import { h } from 'vue';
import { Button } from '@/ui/components/Button';
import { CLICK_EVENTS, trackClick } from '@/services/activityTracker/activityTrackerHelper';
import { openNewTab, isNewTabKey } from '@/ui/helpers';
import { ChecklistRecord } from '@/entities/checklist';
import { router } from '@/ui/routes';
import { tooltip } from '@/ui/components/Tooltip';
import { t } from '@/ui/i18n/i18n';

export const cloneChecklist = (checklist: ChecklistRecord) => {
  const routeObject = {
    name: 'checklistCreate',
    query: { fromId: checklist.id.toString() },
  };

  const { href } = router.resolve(routeObject);

  return tooltip({
    label: t('inspections.duplicate-template'),
    position: 'is-top',
  }, [
    h(Button, {
      class: 'checklist-index-page__action-button',
      props: {
        type: 'is-light',
        tag: 'a',
      },
      on: {
        click: (e: MouseEvent) => {
          trackClick(CLICK_EVENTS.CLONE_TEMPLATE);
          if (isNewTabKey(e)) {
            openNewTab(href);
          } else {
            router.push(routeObject);
          }
        },
      },
      attrs: {
        iconRight: 'clone',
        iconPack: 'far',
        href,
      },
    }),
  ], 'label');
};
